<template>
  <div id="page-content" tabindex="-1">
    <span aria-label="Select Location Page" aria-live="polite" role="contentinfo"></span>
    <h2 class="public-h5 font-weight-bold mt-5 mb-5">
      {{ siteText.ui.selectLocationPageHeader }}
    </h2>
    <p class="text-h8">
      {{ siteText.ui.selectLocationPageSubHeader }}
    </p>
    <p><strong> {{ siteText.ui.selectLocationLocations }} </strong></p>
    <p> {{ availableLocations.length }} {{ siteText.ui.selectLocationNumberOfLocations }} {{searchValue}} </p>
    <div v-for="location in availableLocations" :key="location.Id">
    <v-card>
      <v-card-text class="centerContainer">
         <p>
           {{location.Name}} <br/>
            {{location.Address}} <br/>
            <strong> {{ siteText.ui.selectLocationNextDate }} {{ location.NextAvailableDate }}  </strong> <br/>
            {{ siteText.ui.selectLocationOfficeDistance }} {{ location.Distance }} mi <br/>
        </p>
        <v-layout row wrap class="mt-n1 mb-n1">
        <v-flex md3>
        <v-btn
            class="text-left dmv-btn"
            height="45px"
            width="260px"
            @click="selectThisLocation(location)"
        >
           {{ siteText.ui.selectLocationSelectButton }}
        </v-btn>
        </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <p></p>
    </div>
    <div class="text-left pt-md-4">
      <!-- Desktop Layout -->
      <v-layout row wrap class="hidden-sm-and-down">
      <v-flex md3>
      <v-btn
        class="ma-2 dmv-btn"
        height="45px"
        width="260px"
        @click="back()"
        ><v-icon>mdi-arrow-left</v-icon>
        {{ siteText.ui.selectLocationBack }}
      </v-btn>
      </v-flex>
      <v-flex md3>
      <v-btn
        class="ma-2 dmv-btn"
        height="45px"
        width="260px"
        @click="seeAllLocations()"
      >
        {{ siteText.ui.selectLocationSeeAllLocations }}
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
      </v-flex>
      </v-layout>
      <!-- Mobile Layout -->
      <v-layout row wrap class="hidden-md-and-up">
        <v-flex xs12>
          <v-btn
          class="ma-2 dmv-btn"
          height="45px"
          width="260px"
          @click="seeAllLocations()"
        >
          {{ siteText.ui.selectLocationSeeAllLocations }}
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
        </v-flex>
        <v-flex xs12>
          <v-btn
          class="ma-2 dmv-btn"
          height="45px"
          width="260px"
          @click="back()"
          ><v-icon>mdi-arrow-left</v-icon>
          {{ siteText.ui.selectLocationBack }}
        </v-btn>
        </v-flex>
        </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SelectLocationPage',
  methods: {
    ...mapActions({
      navToSelectAllLocationsPageAction: 'navToSelectAllLocationsPage',
      navToSelectDateTimePageAction: 'navToSelectDateTimePage',
    }),
    ...mapActions(['selectLocation']),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    back() {
      this.$emit('navigateTo', 'SearchLocationPage', { 
          pageName:'Choose a Reservation Location'
      });
    },
    selectThisLocation(location) {
      this.selectLocation(location);
      this.navToSelectDateTimePageAction({ value: 'SelectLocationPage' });
      this.$emit('navigateTo', 'SelectDateTimePage', { 
          pageName:'Select Reservation Date and Time'
      });
    },
    seeAllLocations() {
      this.navToSelectAllLocationsPageAction({ value: 'SelectLocationPage' });
      this.$emit('navigateTo', 'SelectAllLocationsPage', { 
          pageName:'Select Reservation Location'
      });
    },
  },
  computed: {
    ...mapGetters(['siteText']),
    ...mapGetters(['availableLocations']),
    ...mapGetters(['city']),  
    ...mapGetters(['zip']),
    searchValue() {
      let searchValue = this.city;
      if(this.zip) {
        searchValue = this.zip;
      }
      return searchValue;
    }
  },
  mounted() {
    console.log(this.availableLocations);
  }
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
